import type { SVGProps } from 'react'
const IconBuildingOfficeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.025 3.75a.58.58 0 0 0-.582.581v1.566a.75.75 0 0 1-.75.75H6.024a.58.58 0 0 0-.58.58V19.67c0 .321.259.581.58.581h9.919V4.331c0-.32-.26-.581-.581-.581zm-6 18a2.08 2.08 0 0 1-2.082-2.081V7.228c0-1.149.931-2.081 2.081-2.081h3.919V4.33c0-1.15.932-2.081 2.082-2.081h3.337c1.149 0 2.081.932 2.081 2.081v3.92h1.973c1.15 0 2.081.932 2.081 2.08v9.338c0 1.15-.932 2.081-2.08 2.081zm11.418-12h1.973c.32 0 .581.261.581.581v9.338c0 .321-.26.581-.58.581h-1.974z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.547 16.272a.75.75 0 0 1 .88.593l.002.01a.75.75 0 1 1-1.473.286l-.002-.01a.75.75 0 0 1 .593-.88M8.547 12.686a.75.75 0 0 1 .88.593l.002.01a.75.75 0 1 1-1.473.286l-.002-.01a.75.75 0 0 1 .593-.88M8.547 9.018a.75.75 0 0 1 .88.593l.002.01a.75.75 0 1 1-1.473.286l-.002-.01a.75.75 0 0 1 .593-.88M12.55 16.272a.75.75 0 0 1 .88.593l.002.01a.75.75 0 1 1-1.473.286l-.002-.01a.75.75 0 0 1 .593-.88M12.55 12.686a.75.75 0 0 1 .88.593l.002.01a.75.75 0 1 1-1.473.286l-.002-.01a.75.75 0 0 1 .593-.88M12.55 9.018a.75.75 0 0 1 .88.593l.002.01a.75.75 0 1 1-1.473.286l-.002-.01a.75.75 0 0 1 .593-.88"
      clipRule="evenodd"
    />
  </svg>
)
export default IconBuildingOfficeIcon
